/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserResponse } from '../models/UserResponse';
import type { UserUpdateRequest } from '../models/UserUpdateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WhoopUsersResourceV2Service {

    /**
     * @returns UserResponse default response
     * @throws ApiError
     */
    public static getUser1(): CancelablePromise<UserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/user',
        });
    }

    /**
     * @returns any default response
     * @throws ApiError
     */
    public static updateUser1({
        requestBody,
    }: {
        requestBody: UserUpdateRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
